var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgOptimai = function SvgOptimai(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9271_25814)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M14.645 14.242H13.1177C13.0359 14.242 12.9603 14.1971 12.9162 14.1234L8.01004 5.48505C7.9628 5.40494 7.9628 5.30882 8.01004 5.22551L8.77524 3.87977C8.87286 3.70674 9.11849 3.70674 9.21611 3.87977L14.4749 13.1398L14.8717 13.8383C14.9725 14.0145 14.8465 14.2388 14.645 14.2388V14.242Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5069 14.2419C10.4817 14.2515 10.4533 14.2547 10.425 14.2547H8.89458C8.86624 14.2547 8.8379 14.2515 8.81271 14.2419C8.75603 14.2227 8.70564 14.1842 8.67415 14.1266L7.09335 11.3389C6.99573 11.1659 6.75326 11.1659 6.65564 11.3389L5.09373 14.0913C5.0402 14.1842 4.94258 14.2419 4.83551 14.2419H3.35548C3.15079 14.2419 3.02168 14.0176 3.1256 13.835L3.52867 13.1237L6.07307 8.65067C6.22737 8.35909 6.52653 8.15723 6.87292 8.15723C7.21931 8.15723 7.49327 8.33666 7.65387 8.60901H7.66017L10.6454 13.8702C10.7273 14.0176 10.6517 14.1906 10.5069 14.2419Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9271_25814"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.8125,
    height: 10.5,
    fill: "white",
    transform: "translate(3.09375 3.75)"
  })))));
};
export default SvgOptimai;